// extracted by mini-css-extract-plugin
export default {"form":"Submit_form__ff6v2"};